/**
 * Pure flow rules for the manual-order wizard (kept out of the component so they
 * can be tested without rendering).
 */

export const WIZARD_STEPS = ["products", "delivery", "review"];

/**
 * Where the wizard opens.
 *
 * Coming from Sales the products are already chosen, so the wizard skips straight
 * to "Dërgesa & çmimi". A handoff payload is only honoured when the navigation
 * explicitly says it came from Sales: an abandoned payload must never make
 * "Orders -> + Krijo porosi" jump past the product step.
 */
export function resolveWizardEntry({ fromSales, handedLines }) {
  const lines = fromSales && Array.isArray(handedLines) ? handedLines : [];

  return {
    handedLines: lines,
    stepIndex: lines.length ? WIZARD_STEPS.indexOf("delivery") : 0,
    discardStalePayload: !fromSales,
  };
}

/**
 * Unit price the customer pays for a basket line. A staff discount is the typed
 * `finalPrice`; anything empty, invalid or above the catalog price falls back to
 * the catalog price (the form flags it, the server re-validates).
 */
export function resolveBasketUnitPrice(line) {
  const catalogPrice = Number(line.price || 0);
  const raw = line.finalPrice;
  if (raw == null || String(raw).trim() === "") return catalogPrice;
  const typed = Number(String(raw).replace(",", "."));
  if (!Number.isFinite(typed) || typed < 0 || typed > catalogPrice) return catalogPrice;
  return typed;
}

export function basketLinePriceError(line) {
  const raw = line.finalPrice;
  if (raw == null) return null;
  if (String(raw).trim() === "") return "storefrontOrders.finalPriceRequired";
  const typed = Number(String(raw).replace(",", "."));
  if (!Number.isFinite(typed) || typed < 0) return "storefrontOrders.finalPriceInvalid";
  if (typed > Number(line.price || 0)) return "storefrontOrders.finalPriceAboveOriginal";
  return null;
}

export function summarizeBasket(basket) {
  return (basket || []).reduce(
    (summary, line) => ({
      units: summary.units + Number(line.quantity || 0),
      subtotal: summary.subtotal + resolveBasketUnitPrice(line) * Number(line.quantity || 0),
    }),
    { units: 0, subtotal: 0 },
  );
}

/**
 * Prefills THIS order's recipient from a stored customer. The result is a plain
 * copy: editing it changes only the order being created, never the profile.
 */
export function toRecipientFromCustomer(customer) {
  return {
    recipientName: customer?.recipientName || "",
    phone: customer?.phone || "",
    country: customer?.country || "Kosove",
    city: customer?.city || "",
    address: customer?.address || "",
  };
}
